module.exports = __webpack_public_path__ + "e9bbcb23ca71b74318d4358916d0fc1b.svg";